import React, { useEffect } from 'react'
import NewOrder from './NewOrder';

const NewOrderList = ({orderGroup = []}) => {

  return (
    <div>
      <div className='text-xl font-bold'>รายการรอจ่าย</div>
      {orderGroup.length && orderGroup.map((group, index) => (
        <div key={index}>
          <NewOrder group={group}/>
        </div> 
      ))}
    </div>
  )
}

export default NewOrderList